<div class="pad">
  <div>
    <input [attr.type]="passwordVisible ? 'text' : 'password'" placeholder="Mot de passe"  value="" class="form-control input-sm q-main-select q-light-main-focus q-expert-m-2px ng-pristine ng-valid ng-touched" [(ngModel)]="pswd">
    <i [class]="passwordVisible ? 'far fa-eye' : 'far fa-eye-slash'" (click)="togglePasswordVisibility()"></i>
  </div>

  <ng-container *ngIf="enableNumpad">
    <div class="numPad">
      <span *ngFor="let i of tblPad[0]" (click)="addToInput(i)">{{i}}</span>
    </div>
    <div class="numPad">
      <span *ngFor="let j of tblPad[1]" (click)="addToInput(j)">{{j}}</span>
    </div>
  </ng-container>
</div>
